module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "rack",
      "title": "List of Abbreviations and Short Names"
    }
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253044792_Contents#abbrev"
    }
  }, [_vm._v("LIST OF ABBREVIATIONS AND SHORT NAMES")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("ANIC: Arhivele Naţionale Istorice Centrale, National Central Historical Archives, Bucharest")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Fond Cabinetul Consiliului de Miniştri")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Fond: CC al PCR-Cancelarie")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("AINIM: Arhiva Institutului Naţional al Monumentelor Istorice, Archives of the National Institute of Historic Monuments (currently Institutul Naţional al Patrimoniului, National Institute of Patrimony), Bucharest")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("City Museum: Muzeul de Istorie a Oraşului Bucureşti, the Museum of History of the City of Bucharest")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("DHM: Direcţia Monumentelor Istorice, the Department of Historic Monuments (1947–77), Bucharest")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Project Bucharest: Institutul “Proiect Bucureşti,” Bucharest")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("city council: Sfatul Popular al Municipiului Bucureşti, the city people’s council (1947–89)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("city hall: Primăria municipiului Bucureşti, Bucharest’s city hall (1990–)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("State Committee for Architecture: Comitetul de Stat pentru Construcţii, Arhitectură şi Sistematizare, the State Committee for Building, Architecture, and Urban Planning, Bucharest")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("UNESCO archives: Fond Romania, Paris"), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71498794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253044792_Abbreviations.vue
// module id = 84
// module chunks = 0